/**
 * @generated SignedSource<<b3ef7c0d186df9e8324f76de1ceeeb1a>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type Access = "APP" | "BOOK_DOC_AT_PARTNER" | "BOOK_DOC_AT_PHARMACY" | "INBOUND_CALL" | "OUTBOUND_CALL" | "PARTNER_PORTAL" | "WEBSITE" | "WEB_BOOKING";
export type AppointmentStatus = "CANCELLED" | "CLOSED" | "IN_PROGRESS" | "OPEN";
export type AppointmentType = "FLAT_LENGTH_FULL_HOUR" | "FOLLOW_UP" | "LONGER" | "NORMAL";
export type AssociationType = "MANDATORY" | "OPTIONAL";
export type AsyncRequestStatus = "APPROVED" | "REJECTED";
export type BetterDocRejectionReason = "BETTER_DOC_CHOSE_CARE_PROVIDER_BEFOREHAND" | "PATIENT_REFUSES_TO_USE_BETTER_DOC";
export type CallerRole = "DAUGHTER" | "DOMESTIC_PARTNER" | "FATHER" | "GRANDFATHER" | "GRANDMOTHER" | "MOTHER" | "OTHER" | "PATIENT" | "PHARMACY" | "SON";
export type CommunicationChannel = "ASYNC_REQUEST" | "CHAT" | "PHONE" | "VIDEO";
export type ConclusionStatus = "CONCLUDED" | "FAILED" | "IN_CONCLUSION";
export type DeMedicationType = "FREE_TEXT_MEDICATION" | "PREPARATION" | "SUBSTANCE";
export type DocumentType = "AUDIO" | "PDF" | "PHOTO" | "VIDEO";
export type FileUploadStatus = "ERROR" | "HYPERLINK_PROCESSING_FAILED" | "JAVA_SCRIPT_PROCESSING_FAILED" | "MALICIOUS" | "NO_THREAT_FOUND" | "SCAN_TIMEOUT" | "UPLOADED";
export type Language = "ENGLISH" | "FRENCH" | "GERMAN" | "ITALIAN";
export type MedgateConnectChannel = "PARTNER" | "PATIENT";
export type MedicalReportType = "MEDICAL_REPORT" | "OTHER";
export type MedicationUnit = "GTT" | "IU" | "MG" | "ML" | "PC" | "PRN" | "PUFF";
export type PartnerType = "MEAS" | "PHARMACY" | "SPITEX";
export type PointOfCareType = "EMERGENCY_CALL" | "EXTERNAL_ASSISTANCE" | "GENERAL_PRACTITIONER" | "HOSPITAL_ELECTIVE" | "HOSPITAL_EMERGENCY_ROOM" | "INCOMPLETE_TELECONSULTATION" | "MEDICAL_EMERGENCY_OR_PERMANENCE" | "SPECIALIST" | "TELECARE";
export type ProgressNoteKind = "ADMINISTRATIVE" | "MEDICAL";
export type ReasonForChoosingType = "INFRASTRUCTURE" | "PATIENT_REQUEST" | "TIME";
export type RequestType = "NONE" | "ONBOARDING_CALL" | "PLANNED_SELF_REFERRAL" | "PRESCRIPTION" | "PRESCRIPTION_ASTHMA" | "PRESCRIPTION_ATHLETES_FOOT" | "PRESCRIPTION_BLOOD_PRESSURE" | "PRESCRIPTION_CONTRACEPTIVE_PILL" | "PRESCRIPTION_ERECTILE_DYSFUNCTION" | "PRESCRIPTION_HAY_FEVER" | "PRESCRIPTION_HEARTBURN" | "PRESCRIPTION_HYPOTHYROIDISM" | "PRESCRIPTION_MIGRAINE" | "PRESCRIPTION_URINARY_TRACT_INFECTION" | "PRESCRIPTION_VAGINAL_MYCOSIS" | "REFERRAL" | "SICK_LEAVE_CERTIFICATE" | "SICK_LEAVE_FOR_LEGAL_GUARDIAN" | "SKIN_CHECK";
export type Service = "ADMINISTRATIVE_REQUEST" | "CONSULTATION" | "EMERGENCY_LINE" | "KIDS_LINE" | "MEDGATE_CONNECT" | "PREVENTION_ASSESSMENT" | "PSYCHOSOCIAL" | "STUDY_CALL" | "TELE_GENERAL_PRACTITIONER";
export type ServiceSpecialty = "CARDIOLOGY" | "DERMATOLOGY" | "GYNAECOLOGY" | "LONG_COVID" | "NONE" | "OTORHINOLARYNGOLOGY" | "PEDIATRICS" | "UROLOGY" | "VACCINATION_AND_TRAVEL_ADVICE";
export type TimeToTreatType = "LATER" | "URGENT" | "WITHIN12H" | "WITHIN14DAYS" | "WITHIN24H" | "WITHIN48H" | "WITHIN6H";
export type de_BetterDocProgressNoteResultKind = "CARE_PROVIDERS_RECOMMENDED" | "MSN" | "NO_RESULT";
import { FragmentRefs } from "relay-runtime";
export type deEpisodeOfCareFragment$data = {
  readonly createdAt: string;
  readonly createdBy: string;
  readonly icdDiagnosis: {
    readonly associationType: AssociationType | null;
    readonly diagnosisCode: string;
    readonly id: string;
    readonly isAssociation: boolean;
    readonly primaryCode: string | null;
    readonly secondaryCode: string | null;
    readonly text: string;
  };
  readonly id: string;
  readonly isUpdatable: boolean;
  readonly isVirtual: boolean;
  readonly patientId: string;
  readonly progressNotes: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly __typename: "de_ProgressNote";
        readonly anamnesis: string | null;
        readonly appointment: {
          readonly access: Access;
          readonly appointmentAttachments: ReadonlyArray<{
            readonly " $fragmentSpreads": FragmentRefs<"AppointmentAttachmentFragment">;
          }>;
          readonly appointmentType: AppointmentType;
          readonly asyncRequestStatus: AsyncRequestStatus | null;
          readonly billingAttribute: {
            readonly " $fragmentSpreads": FragmentRefs<"BillingAttributeFragment">;
          } | null;
          readonly callerRole: CallerRole | null;
          readonly canUseDoc2U: boolean;
          readonly channel: CommunicationChannel;
          readonly completedAt: string | null;
          readonly conclusionStatus: ConclusionStatus | null;
          readonly createdAt: string;
          readonly hasChatTranscript: boolean;
          readonly healthOverview: {
            readonly generalHealthInformation: {
              readonly " $fragmentSpreads": FragmentRefs<"GeneralHealthInformationFragment">;
            } | null;
            readonly vitalSign: {
              readonly " $fragmentSpreads": FragmentRefs<"VitalSignFragment">;
            } | null;
          } | null;
          readonly id: string;
          readonly isCompleted: boolean;
          readonly isInvoiced: boolean;
          readonly isPartnerInVideoCall: boolean;
          readonly language: Language;
          readonly medgateConnectChannel: MedgateConnectChannel | null;
          readonly partnerType: PartnerType | null;
          readonly partnerUserEmail: string | null;
          readonly patientAddress: {
            readonly city: string;
            readonly countryCode: string;
            readonly houseNumberStreet: string;
            readonly postalCode: string;
          } | null;
          readonly patientPhoneNumber: string | null;
          readonly questionnaireCriticalitySummary: {
            readonly " $fragmentSpreads": FragmentRefs<"QuestionnaireCriticalitySummaryFragment">;
          } | null;
          readonly questionnaireId: number | null;
          readonly reason: string;
          readonly requestType: RequestType;
          readonly service: Service;
          readonly specialty: ServiceSpecialty;
          readonly status: AppointmentStatus;
          readonly suggestedQuestionnaireDiagnosisCodes: ReadonlyArray<{
            readonly diagnosisCode: string;
            readonly id: string;
            readonly text: string;
          }>;
          readonly telephoneLine: {
            readonly telephoneLineTranslations: ReadonlyArray<{
              readonly content: string;
              readonly language: Language;
            }>;
          } | null;
          readonly " $fragmentSpreads": FragmentRefs<"RequestedMedicationsFragment">;
        };
        readonly attestationGuardian: {
          readonly concludedAt: string | null;
          readonly concludedBy: string | null;
          readonly createdAt: string;
          readonly createdBy: string;
          readonly durationFrom: any;
          readonly durationTo: any;
          readonly fileId: string | null;
          readonly fileMetadata: {
            readonly documentType: string;
            readonly extension: string;
            readonly lengthInKilobytes: number;
          } | null;
          readonly firstName: string;
          readonly id: string;
          readonly lastName: string;
          readonly progressNoteId: string;
          readonly signedAt: string | null;
          readonly signedBy: string | null;
          readonly updatedAt: string | null;
          readonly updatedBy: string | null;
          readonly " $fragmentSpreads": FragmentRefs<"deLegalGuardianAttestationFragment">;
        } | null;
        readonly betterDoc: {
          readonly isUsed: boolean | null;
          readonly rejectionReason: BetterDocRejectionReason | null;
        } | null;
        readonly betterDocResult: {
          readonly kind: de_BetterDocProgressNoteResultKind;
          readonly recommendedCareProviders: ReadonlyArray<{
            readonly city: string | null;
            readonly name: string | null;
            readonly position: number;
            readonly postalCode: string | null;
            readonly street: string | null;
            readonly workplaceName: string | null;
          }>;
          readonly sessionId: number;
        } | null;
        readonly carePlanSummary: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly concludedAt: string | null;
              readonly concludedBy: string | null;
              readonly createdAt: string;
              readonly createdBy: string;
              readonly fileId: string | null;
              readonly fileMetadata: {
                readonly documentType: string;
                readonly extension: string;
                readonly lengthInKilobytes: number;
              } | null;
              readonly id: string;
              readonly progressNoteId: string;
              readonly signedAt: string | null;
              readonly signedBy: string | null;
              readonly treatmentPlan: {
                readonly followUpTreatment: string;
                readonly from: any;
                readonly recommendedTreatment: string;
                readonly title: string;
                readonly to: any;
              };
              readonly updatedAt: string | null;
              readonly updatedBy: string | null;
            };
          }> | null;
        } | null;
        readonly createdAt: string;
        readonly createdBy: string;
        readonly de_callTranscripts: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly callTranscriptEndedAt: string;
              readonly id: string;
              readonly transcript: ReadonlyArray<{
                readonly id: string;
                readonly text: string;
              }>;
            };
          }> | null;
        } | null;
        readonly de_recommendedMedications: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly id: string;
              readonly medication: {
                readonly __typename: "de_Medication";
                readonly composition: string | null;
                readonly createdAt: string;
                readonly createdBy: string;
                readonly endDate: any | null;
                readonly eveningDosage: number;
                readonly id: string;
                readonly internalNotes: string | null;
                readonly isPermanentPrescription: boolean;
                readonly isPrescriptionRequired: boolean;
                readonly morningDosage: number;
                readonly name: string;
                readonly nightDosage: number;
                readonly noonDosage: number;
                readonly numberOfPackages: number;
                readonly patientId: string;
                readonly pharmaceuticalCentralNumber: string | null;
                readonly refuseSubstitutes: boolean;
                readonly startDate: any | null;
                readonly type: DeMedicationType;
                readonly unit: MedicationUnit;
                readonly updatedAt: string | null;
                readonly updatedBy: string | null;
                readonly usageInstructions: string | null;
              };
              readonly medicationId: number;
              readonly patientId: string;
              readonly progressNoteId: number;
            };
          }> | null;
        } | null;
        readonly episodeOfCareId: string | null;
        readonly followUpAppointment: {
          readonly assignedTo: string | null;
          readonly completedAt: string | null;
          readonly date: any;
          readonly id: string;
          readonly initialAssignedToUser: {
            readonly firstName: string;
            readonly id: string;
            readonly lastName: string;
          } | null;
          readonly initialBookedDateTime: string;
          readonly rescheduledAt: string | null;
          readonly rescheduledBy: string | null;
          readonly rescheduledByUser: {
            readonly firstName: string;
            readonly id: string;
            readonly lastName: string;
          } | null;
          readonly slotId: number;
          readonly status: AppointmentStatus;
          readonly takenBy: string | null;
        } | null;
        readonly generalAttestation: {
          readonly concludedAt: string | null;
          readonly concludedBy: string | null;
          readonly createdAt: string;
          readonly createdBy: string;
          readonly fileId: string | null;
          readonly fileMetadata: {
            readonly documentType: string;
            readonly extension: string;
            readonly lengthInKilobytes: number;
          } | null;
          readonly id: string;
          readonly name: string;
          readonly progressNoteId: string;
          readonly signedAt: string | null;
          readonly signedBy: string | null;
          readonly subject: string;
          readonly updatedAt: string | null;
          readonly updatedBy: string | null;
          readonly " $fragmentSpreads": FragmentRefs<"deGeneralAttestationsFragment">;
        } | null;
        readonly id: string;
        readonly kind: ProgressNoteKind;
        readonly medicalReportAttachments: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly attachmentType: DocumentType;
              readonly createdAt: string;
              readonly fileName: string;
              readonly id: string;
              readonly progressNoteId: string;
              readonly reportType: MedicalReportType;
              readonly sessionId: string;
              readonly uploadStatus: FileUploadStatus | null;
              readonly url: string;
            };
          }> | null;
        } | null;
        readonly pointOfCare: {
          readonly __typename: "de_PointOfCare";
          readonly actual: PointOfCareType | null;
          readonly careProviderId: number | null;
          readonly isDoctorVisitAvoided: boolean | null;
          readonly medical: PointOfCareType;
          readonly pointOfCareSpecialty: {
            readonly betterDocKey: string | null;
            readonly id: string;
            readonly specialtyTranslations: ReadonlyArray<{
              readonly language: string;
              readonly name: string;
            }>;
            readonly synonym: string | null;
            readonly word: string;
          } | null;
          readonly purpose: {
            readonly instrumentalExamination: boolean | null;
            readonly laboratory: boolean | null;
            readonly physicalExam: boolean | null;
          } | null;
          readonly reasonForChoosingActual: ReasonForChoosingType | null;
          readonly specialtyId: number | null;
          readonly timeToTreatType: TimeToTreatType | null;
        } | null;
        readonly prescription: {
          readonly concludedAt: string | null;
          readonly concludedBy: string | null;
          readonly createdBy: string;
          readonly fileId: string | null;
          readonly fileMetadata: {
            readonly documentType: string;
            readonly extension: string;
            readonly lengthInKilobytes: number;
          } | null;
          readonly id: string;
          readonly medications: ReadonlyArray<{
            readonly id: string;
          }>;
          readonly signedAt: string | null;
          readonly signedBy: string | null;
          readonly updatedBy: string | null;
          readonly " $fragmentSpreads": FragmentRefs<"dePrescriptionFragment">;
        } | null;
        readonly progressNoteId: number;
        readonly referralLetter: {
          readonly concludedAt: string | null;
          readonly concludedBy: string | null;
          readonly createdAt: string;
          readonly createdBy: string;
          readonly fileId: string | null;
          readonly fileMetadata: {
            readonly documentType: string;
            readonly extension: string;
            readonly lengthInKilobytes: number;
          } | null;
          readonly id: string;
          readonly progressNoteId: string;
          readonly signedAt: string | null;
          readonly signedBy: string | null;
          readonly updatedAt: string | null;
          readonly updatedBy: string | null;
          readonly " $fragmentSpreads": FragmentRefs<"deReferralLetterFragment">;
        } | null;
        readonly sickLeave: {
          readonly concludedAt: string | null;
          readonly concludedBy: string | null;
          readonly createdAt: string;
          readonly createdBy: string;
          readonly fileId: string | null;
          readonly fileMetadata: {
            readonly documentType: string;
            readonly extension: string;
            readonly lengthInKilobytes: number;
          } | null;
          readonly from: any;
          readonly id: string;
          readonly progressNoteId: string;
          readonly signedAt: string | null;
          readonly signedBy: string | null;
          readonly to: any;
          readonly updatedAt: string | null;
          readonly updatedBy: string | null;
          readonly " $fragmentSpreads": FragmentRefs<"deSickLeaveFragment">;
        } | null;
        readonly therapyPrescription: {
          readonly concludedAt: string | null;
          readonly concludedBy: string | null;
          readonly createdAt: string;
          readonly createdBy: string;
          readonly diagnosisCode: string;
          readonly fileId: string | null;
          readonly fileMetadata: {
            readonly documentType: string;
            readonly extension: string;
            readonly lengthInKilobytes: number;
          } | null;
          readonly id: string;
          readonly progressNoteId: string;
          readonly signedAt: string | null;
          readonly signedBy: string | null;
          readonly updatedAt: string | null;
          readonly updatedBy: string | null;
          readonly " $fragmentSpreads": FragmentRefs<"deTherapyPrescriptionFragment">;
        } | null;
        readonly treatmentPlan: {
          readonly followUpInstructions: string | null;
          readonly from: any;
          readonly recommended: string | null;
          readonly title: string;
          readonly to: any;
        } | null;
        readonly updatedAt: string;
        readonly updatedBy: string;
        readonly " $fragmentSpreads": FragmentRefs<"deProgressNoteFragment">;
      };
    }> | null;
  } | null;
  readonly relatedConditions: ReadonlyArray<{
    readonly icdDiagnosis: {
      readonly associationType: AssociationType | null;
      readonly diagnosisCode: string;
      readonly id: string;
      readonly isAssociation: boolean;
      readonly primaryCode: string | null;
      readonly secondaryCode: string | null;
      readonly text: string;
    };
    readonly id: string;
  }>;
  readonly updatedAt: string;
  readonly " $fragmentType": "deEpisodeOfCareFragment";
};
export type deEpisodeOfCareFragment$key = {
  readonly " $data"?: deEpisodeOfCareFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"deEpisodeOfCareFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "diagnosisCode",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "IcdDiagnosis",
  "kind": "LinkedField",
  "name": "icdDiagnosis",
  "plural": false,
  "selections": [
    (v0/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isAssociation",
      "storageKey": null
    },
    (v1/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "primaryCode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "secondaryCode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "associationType",
      "storageKey": null
    },
    (v2/*:: as any*/)
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "patientId",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdBy",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedAt",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "progressNoteId",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "language",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "completedAt",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "city",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "postalCode",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v18 = [
  (v0/*:: as any*/),
  (v16/*:: as any*/),
  (v17/*:: as any*/)
],
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedBy",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "from",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "to",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fileId",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "signedAt",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "signedBy",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "concludedAt",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "concludedBy",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "concreteType": "DocumentFileMetadata",
  "kind": "LinkedField",
  "name": "fileMetadata",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "documentType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "extension",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lengthInKilobytes",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sessionId",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "progressNotes"
        ]
      }
    ]
  },
  "name": "deEpisodeOfCareFragment",
  "selections": [
    (v0/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isVirtual",
      "storageKey": null
    },
    (v3/*:: as any*/),
    (v4/*:: as any*/),
    (v5/*:: as any*/),
    (v6/*:: as any*/),
    (v7/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isUpdatable",
      "storageKey": null
    },
    {
      "alias": "progressNotes",
      "args": null,
      "concreteType": "de_ProgressNoteConnection",
      "kind": "LinkedField",
      "name": "__EpisodeOfCareProgressNotesConnection_progressNotes_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "de_ProgressNoteEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "de_ProgressNote",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v8/*:: as any*/),
                (v0/*:: as any*/),
                (v9/*:: as any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "episodeOfCareId",
                  "storageKey": null
                },
                (v10/*:: as any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Appointment",
                  "kind": "LinkedField",
                  "name": "appointment",
                  "plural": false,
                  "selections": [
                    (v0/*:: as any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "access",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "appointmentType",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "conclusionStatus",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "asyncRequestStatus",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "specialty",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "service",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "patientPhoneNumber",
                      "storageKey": null
                    },
                    (v6/*:: as any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "reason",
                      "storageKey": null
                    },
                    (v11/*:: as any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isCompleted",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isInvoiced",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isPartnerInVideoCall",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "questionnaireId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "QuestionnaireCriticalitySummaryOutput",
                      "kind": "LinkedField",
                      "name": "questionnaireCriticalitySummary",
                      "plural": false,
                      "selections": [
                        {
                          "args": null,
                          "kind": "FragmentSpread",
                          "name": "QuestionnaireCriticalitySummaryFragment"
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "channel",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "callerRole",
                      "storageKey": null
                    },
                    (v12/*:: as any*/),
                    (v13/*:: as any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hasChatTranscript",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "canUseDoc2U",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "ch_TelephoneLine",
                      "kind": "LinkedField",
                      "name": "telephoneLine",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "ch_TelephoneLineTranslation",
                          "kind": "LinkedField",
                          "name": "telephoneLineTranslations",
                          "plural": true,
                          "selections": [
                            (v12/*:: as any*/),
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "content",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "AppointmentAttachment",
                      "kind": "LinkedField",
                      "name": "appointmentAttachments",
                      "plural": true,
                      "selections": [
                        {
                          "args": null,
                          "kind": "FragmentSpread",
                          "name": "AppointmentAttachmentFragment"
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Address",
                      "kind": "LinkedField",
                      "name": "patientAddress",
                      "plural": false,
                      "selections": [
                        (v14/*:: as any*/),
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "countryCode",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "houseNumberStreet",
                          "storageKey": null
                        },
                        (v15/*:: as any*/)
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "BillingAttribute",
                      "kind": "LinkedField",
                      "name": "billingAttribute",
                      "plural": false,
                      "selections": [
                        {
                          "args": null,
                          "kind": "FragmentSpread",
                          "name": "BillingAttributeFragment"
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "HealthOverview",
                      "kind": "LinkedField",
                      "name": "healthOverview",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "VitalSign",
                          "kind": "LinkedField",
                          "name": "vitalSign",
                          "plural": false,
                          "selections": [
                            {
                              "args": null,
                              "kind": "FragmentSpread",
                              "name": "VitalSignFragment"
                            }
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "GeneralHealthInformation",
                          "kind": "LinkedField",
                          "name": "generalHealthInformation",
                          "plural": false,
                          "selections": [
                            {
                              "args": null,
                              "kind": "FragmentSpread",
                              "name": "GeneralHealthInformationFragment"
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "RequestedMedicationsFragment"
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "requestType",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "IcdDiagnosis",
                      "kind": "LinkedField",
                      "name": "suggestedQuestionnaireDiagnosisCodes",
                      "plural": true,
                      "selections": [
                        (v1/*:: as any*/),
                        (v0/*:: as any*/),
                        (v2/*:: as any*/)
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "partnerUserEmail",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "medgateConnectChannel",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "partnerType",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Appointment",
                  "kind": "LinkedField",
                  "name": "followUpAppointment",
                  "plural": false,
                  "selections": [
                    (v0/*:: as any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "date",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "slotId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "assignedTo",
                      "storageKey": null
                    },
                    (v11/*:: as any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "initialBookedDateTime",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "MedgateEmployee",
                      "kind": "LinkedField",
                      "name": "initialAssignedToUser",
                      "plural": false,
                      "selections": (v18/*:: as any*/),
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "rescheduledBy",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "rescheduledAt",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "MedgateEmployee",
                      "kind": "LinkedField",
                      "name": "rescheduledByUser",
                      "plural": false,
                      "selections": (v18/*:: as any*/),
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "takenBy",
                      "storageKey": null
                    },
                    (v13/*:: as any*/)
                  ],
                  "storageKey": null
                },
                (v5/*:: as any*/),
                (v19/*:: as any*/),
                (v7/*:: as any*/),
                (v6/*:: as any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "de_ProgressNoteBetterDoc",
                  "kind": "LinkedField",
                  "name": "betterDoc",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isUsed",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "rejectionReason",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "de_PointOfCare",
                  "kind": "LinkedField",
                  "name": "pointOfCare",
                  "plural": false,
                  "selections": [
                    (v8/*:: as any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "medical",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "actual",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "reasonForChoosingActual",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isDoctorVisitAvoided",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "careProviderId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Purpose",
                      "kind": "LinkedField",
                      "name": "purpose",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "physicalExam",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "laboratory",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "instrumentalExamination",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "specialtyId",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "PointOfCareSpecialty",
                      "kind": "LinkedField",
                      "name": "pointOfCareSpecialty",
                      "plural": false,
                      "selections": [
                        (v0/*:: as any*/),
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "word",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "synonym",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "PointOfCareSpecialtyTranslation",
                          "kind": "LinkedField",
                          "name": "specialtyTranslations",
                          "plural": true,
                          "selections": [
                            (v12/*:: as any*/),
                            (v20/*:: as any*/)
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "betterDocKey",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "timeToTreatType",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "TreatmentPlan",
                  "kind": "LinkedField",
                  "name": "treatmentPlan",
                  "plural": false,
                  "selections": [
                    (v21/*:: as any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "followUpInstructions",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "recommended",
                      "storageKey": null
                    },
                    (v22/*:: as any*/),
                    (v23/*:: as any*/)
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "anamnesis",
                  "storageKey": null
                },
                {
                  "alias": "therapyPrescription",
                  "args": null,
                  "concreteType": "de_TherapyPrescription",
                  "kind": "LinkedField",
                  "name": "de_therapyPrescription",
                  "plural": false,
                  "selections": [
                    (v0/*:: as any*/),
                    (v24/*:: as any*/),
                    (v9/*:: as any*/),
                    (v1/*:: as any*/),
                    (v25/*:: as any*/),
                    (v26/*:: as any*/),
                    (v7/*:: as any*/),
                    (v6/*:: as any*/),
                    (v19/*:: as any*/),
                    (v5/*:: as any*/),
                    (v27/*:: as any*/),
                    (v28/*:: as any*/),
                    (v29/*:: as any*/),
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "deTherapyPrescriptionFragment"
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": "sickLeave",
                  "args": null,
                  "concreteType": "de_SickLeave",
                  "kind": "LinkedField",
                  "name": "de_sickLeave",
                  "plural": false,
                  "selections": [
                    (v0/*:: as any*/),
                    (v24/*:: as any*/),
                    (v9/*:: as any*/),
                    (v25/*:: as any*/),
                    (v26/*:: as any*/),
                    (v7/*:: as any*/),
                    (v6/*:: as any*/),
                    (v19/*:: as any*/),
                    (v5/*:: as any*/),
                    (v22/*:: as any*/),
                    (v23/*:: as any*/),
                    (v27/*:: as any*/),
                    (v28/*:: as any*/),
                    (v29/*:: as any*/),
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "deSickLeaveFragment"
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": "generalAttestation",
                  "args": null,
                  "concreteType": "de_GeneralAttestation",
                  "kind": "LinkedField",
                  "name": "de_generalAttestation",
                  "plural": false,
                  "selections": [
                    (v0/*:: as any*/),
                    (v24/*:: as any*/),
                    (v9/*:: as any*/),
                    (v26/*:: as any*/),
                    (v25/*:: as any*/),
                    (v7/*:: as any*/),
                    (v6/*:: as any*/),
                    (v19/*:: as any*/),
                    (v5/*:: as any*/),
                    (v20/*:: as any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "subject",
                      "storageKey": null
                    },
                    (v27/*:: as any*/),
                    (v28/*:: as any*/),
                    (v29/*:: as any*/),
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "deGeneralAttestationsFragment"
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": "attestationGuardian",
                  "args": null,
                  "concreteType": "de_AttestationGuardian",
                  "kind": "LinkedField",
                  "name": "de_attestationGuardian",
                  "plural": false,
                  "selections": [
                    (v0/*:: as any*/),
                    (v16/*:: as any*/),
                    (v17/*:: as any*/),
                    (v24/*:: as any*/),
                    (v9/*:: as any*/),
                    (v26/*:: as any*/),
                    (v25/*:: as any*/),
                    (v7/*:: as any*/),
                    (v6/*:: as any*/),
                    (v19/*:: as any*/),
                    (v5/*:: as any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "durationFrom",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "durationTo",
                      "storageKey": null
                    },
                    (v27/*:: as any*/),
                    (v28/*:: as any*/),
                    (v29/*:: as any*/),
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "deLegalGuardianAttestationFragment"
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": "referralLetter",
                  "args": null,
                  "concreteType": "de_ReferralLetter",
                  "kind": "LinkedField",
                  "name": "de_referralLetter",
                  "plural": false,
                  "selections": [
                    (v0/*:: as any*/),
                    (v24/*:: as any*/),
                    (v9/*:: as any*/),
                    (v26/*:: as any*/),
                    (v25/*:: as any*/),
                    (v7/*:: as any*/),
                    (v6/*:: as any*/),
                    (v19/*:: as any*/),
                    (v5/*:: as any*/),
                    (v27/*:: as any*/),
                    (v28/*:: as any*/),
                    (v29/*:: as any*/),
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "deReferralLetterFragment"
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": "betterDocResult",
                  "args": null,
                  "concreteType": "de_ProgressNoteBetterDocResult",
                  "kind": "LinkedField",
                  "name": "de_betterDocResult",
                  "plural": false,
                  "selections": [
                    (v30/*:: as any*/),
                    (v10/*:: as any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "de_BetterDocRecommendedCareProvider",
                      "kind": "LinkedField",
                      "name": "recommendedCareProviders",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "position",
                          "storageKey": null
                        },
                        (v20/*:: as any*/),
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "workplaceName",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "street",
                          "storageKey": null
                        },
                        (v15/*:: as any*/),
                        (v14/*:: as any*/)
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": "carePlanSummary",
                  "args": null,
                  "concreteType": "De_carePlanSummaryConnection",
                  "kind": "LinkedField",
                  "name": "__ProgressNoteConnection_carePlanSummary_connection",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "De_carePlanSummaryEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "CarePlanSummary",
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            (v0/*:: as any*/),
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "CarePlanTreatmentPlan",
                              "kind": "LinkedField",
                              "name": "treatmentPlan",
                              "plural": false,
                              "selections": [
                                (v21/*:: as any*/),
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "followUpTreatment",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "recommendedTreatment",
                                  "storageKey": null
                                },
                                (v22/*:: as any*/),
                                (v23/*:: as any*/)
                              ],
                              "storageKey": null
                            },
                            (v24/*:: as any*/),
                            (v9/*:: as any*/),
                            (v26/*:: as any*/),
                            (v25/*:: as any*/),
                            (v7/*:: as any*/),
                            (v6/*:: as any*/),
                            (v19/*:: as any*/),
                            (v5/*:: as any*/),
                            (v27/*:: as any*/),
                            (v28/*:: as any*/),
                            (v29/*:: as any*/),
                            (v8/*:: as any*/)
                          ],
                          "storageKey": null
                        },
                        (v31/*:: as any*/)
                      ],
                      "storageKey": null
                    },
                    (v32/*:: as any*/)
                  ],
                  "storageKey": null
                },
                {
                  "alias": "prescription",
                  "args": null,
                  "concreteType": "de_Prescription",
                  "kind": "LinkedField",
                  "name": "de_prescription",
                  "plural": false,
                  "selections": [
                    (v0/*:: as any*/),
                    (v25/*:: as any*/),
                    (v26/*:: as any*/),
                    (v27/*:: as any*/),
                    (v28/*:: as any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "de_Medication",
                      "kind": "LinkedField",
                      "name": "medications",
                      "plural": true,
                      "selections": [
                        (v0/*:: as any*/)
                      ],
                      "storageKey": null
                    },
                    (v5/*:: as any*/),
                    (v19/*:: as any*/),
                    (v24/*:: as any*/),
                    (v29/*:: as any*/),
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "dePrescriptionFragment"
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": "medicalReportAttachments",
                  "args": null,
                  "concreteType": "MedicalReportAttachmentConnection",
                  "kind": "LinkedField",
                  "name": "__ProgressNoteConnection_medicalReportAttachments_connection",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "MedicalReportAttachmentEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "MedicalReportAttachment",
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            (v0/*:: as any*/),
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "url",
                              "storageKey": null
                            },
                            (v6/*:: as any*/),
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "attachmentType",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "fileName",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "uploadStatus",
                              "storageKey": null
                            },
                            (v9/*:: as any*/),
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "reportType",
                              "storageKey": null
                            },
                            (v30/*:: as any*/),
                            (v8/*:: as any*/)
                          ],
                          "storageKey": null
                        },
                        (v31/*:: as any*/)
                      ],
                      "storageKey": null
                    },
                    (v32/*:: as any*/)
                  ],
                  "storageKey": null
                },
                {
                  "alias": "de_recommendedMedications",
                  "args": null,
                  "concreteType": "De_recommendedMedicationsConnection",
                  "kind": "LinkedField",
                  "name": "__ProgressNoteConnection_de_recommendedMedications_connection",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "De_recommendedMedicationsEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "de_RecommendedMedication",
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            (v9/*:: as any*/),
                            (v4/*:: as any*/),
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "medicationId",
                              "storageKey": null
                            },
                            (v0/*:: as any*/),
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "de_Medication",
                              "kind": "LinkedField",
                              "name": "medication",
                              "plural": false,
                              "selections": [
                                (v8/*:: as any*/),
                                (v0/*:: as any*/),
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "refuseSubstitutes",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "numberOfPackages",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "endDate",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "eveningDosage",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "internalNotes",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "isPrescriptionRequired",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "morningDosage",
                                  "storageKey": null
                                },
                                (v20/*:: as any*/),
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "nightDosage",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "noonDosage",
                                  "storageKey": null
                                },
                                (v4/*:: as any*/),
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "pharmaceuticalCentralNumber",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "startDate",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "unit",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "usageInstructions",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "composition",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "type",
                                  "storageKey": null
                                },
                                (v7/*:: as any*/),
                                (v19/*:: as any*/),
                                (v6/*:: as any*/),
                                (v5/*:: as any*/),
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "isPermanentPrescription",
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            },
                            (v8/*:: as any*/)
                          ],
                          "storageKey": null
                        },
                        (v31/*:: as any*/)
                      ],
                      "storageKey": null
                    },
                    (v32/*:: as any*/)
                  ],
                  "storageKey": null
                },
                {
                  "alias": "de_callTranscripts",
                  "args": null,
                  "concreteType": "De_callTranscriptsConnection",
                  "kind": "LinkedField",
                  "name": "__ProgressNoteConnection_de_callTranscripts_connection",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "De_callTranscriptsEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "CallTranscript",
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            (v0/*:: as any*/),
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "TranscriptEntry",
                              "kind": "LinkedField",
                              "name": "transcript",
                              "plural": true,
                              "selections": [
                                (v0/*:: as any*/),
                                (v2/*:: as any*/)
                              ],
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "callTranscriptEndedAt",
                              "storageKey": null
                            },
                            (v8/*:: as any*/)
                          ],
                          "storageKey": null
                        },
                        (v31/*:: as any*/)
                      ],
                      "storageKey": null
                    },
                    (v32/*:: as any*/)
                  ],
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "deProgressNoteFragment"
                }
              ],
              "storageKey": null
            },
            (v31/*:: as any*/)
          ],
          "storageKey": null
        },
        (v32/*:: as any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "RelatedCondition",
      "kind": "LinkedField",
      "name": "relatedConditions",
      "plural": true,
      "selections": [
        (v0/*:: as any*/),
        (v3/*:: as any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "de_EpisodeOfCare",
  "abstractKey": null
};
})();

(node as any).hash = "aebb926a2b28245c00b6f641ef803463";

export default node;
